module.exports = {
      id: "bundle-usage",
      viewBox: "0 0 15.204 15.204",
      url: "/" + "sprite-ab56b996b385d9abaaf31e01c38c81cd.svg#bundle",
      toString: function () {
        return this.url;
      }
    }